import {
    setGlobalConfigurationData,
    getGlobalConfigurationDataFailed,
} from "./actions"
import platformConfigAPI from "../../api/config-api"
import { LEGALDISCLAIMER } from "../../constants/common-const"
import * as types from "./types"
import { ofType } from "redux-observable"
import { from, of } from "rxjs"
import { switchMap, catchError, mergeMap } from "rxjs/operators"

export function getGlobalConfigurations(action$) {
    return action$.pipe(
        ofType(types.GET_GLOBAL_CONFIG_DATA),
        mergeMap((action) =>
            from(
                platformConfigAPI.getGlobalConfigurationData(
                    LEGALDISCLAIMER.configType
                )
            ).pipe(
                mergeMap((response) => {
                    return of(setGlobalConfigurationData(response.data[0]))
                }),
                catchError((error) => {
                    return of(getGlobalConfigurationDataFailed(error))
                })
            )
        )
    )
}
